import React, { PropsWithChildren, useState } from 'react';
import { IActivePlan } from '../../interfaces/IActivePlan';
import Grid from '@material-ui/core/Grid';
import {
  Button,
  ButtonGroup,
  Checkbox,
  List,
  MenuItem,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import CurrentPlanItem from '../CurrentPlanItem';
import moment from 'moment';
import { StyledDivider } from '../StyledDivider';
import colors from '../../../../styles/colors';
import { premiumCancellationReasons } from '../../../../enums/CancellationReasons';

interface CancellationViewProps {
  activePlan: IActivePlan;
  goBack(): void;
  handleCancellation(subscriptionId: string, cancellationReason: string): any;
}

const CancellationView = (props: PropsWithChildren<CancellationViewProps>) => {
  const { activePlan, goBack, handleCancellation } = props;
  const [cancellationReason, setCancellationReason] = useState(0);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant={'h4'}>Cancel your plan</Typography>
      </Grid>
      <Grid item xs={12}>
        <strong>Current Plan</strong>
        <StyledDivider />
        <CurrentPlanItem showRenewal={false} plan={activePlan} />
      </Grid>
      <Grid item xs={12}>
        <Typography>
          Your plan will be cancelled at the end of the subscription period on{' '}
          {moment(activePlan.renewalDate).format('MMMM Do, YYYY')}.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List>
          <RadioGroup>
            {premiumCancellationReasons.map((reason: string, index: number) => {
              return (
                <MenuItem key={index}>
                  <Radio
                    color={'primary'}
                    onChange={() => {
                      setCancellationReason(index);
                    }}
                    value={index}
                    checked={index === cancellationReason}
                  />{' '}
                  {reason}
                </MenuItem>
              );
            })}
          </RadioGroup>
        </List>
      </Grid>
      <Grid item xs={12}>
        <Button
          onClick={goBack}
          style={{ backgroundColor: 'grey', color: 'white' }}
        >
          Go back
        </Button>
        &nbsp;
        <Button
          style={{
            backgroundColor: colors.red,
            padding: 'inherit 1rem',
            color: 'white'
          }}
          onClick={() => {
            handleCancellation(
              activePlan.id,
              premiumCancellationReasons[cancellationReason]
            );
          }}
        >
          Cancel
        </Button>
      </Grid>
    </Grid>
  );
};
export default CancellationView;
